import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ConcessionarioPessoaTipoVinculo } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-tipo-vinculo';
import { ConcessionarioPessoaSearch } from 'app/services/mob/concessionario-pessoa.search';
import { ConcessionarioPessoaService } from 'app/services/mob/concessionario-pessoa.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
@Component({
  selector: 'grid-representantes',
  templateUrl: './grid-representantes.component.html',
  styleUrls: ['./grid-representantes.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class GridRepresentantesComponent implements OnInit {

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['nome', 'cpf', 'celular', 'telefone', 'email'];
  formGroup: FormGroup;
  cdConcessao: number;
  paginatorLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 10;


  constructor(
    private _concessionarioPessoaService: ConcessionarioPessoaService,
    private _controlContainer: ControlContainer,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.cdConcessao = +this._activatedRoute.snapshot.params["cdConcessao"];
  }
  
  ngAfterViewInit() {
    this.load(0);
  }
  
  _onPageChange(val) {
    this.pageIndex = val.pageIndex;
    this.load(this.pageIndex + 1)
  }

  async load(page: number) {
    try {
      if(this.cdConcessao > 0){
        let filter = new ConcessionarioPessoaSearch(this.formGroup.value);
        filter.limit = this.pageSize;
        filter.page = page;
        filter.cdConcessao = this.cdConcessao;
        filter.tpVinculo = ConcessionarioPessoaTipoVinculo.REPRESENTANTE;
        this._concessionarioPessoaService.findConcessionarioPessoa(filter).then(result => {
          this.paginatorLength = result.total;
          this.dataSource = new MatTableDataSource(result.items);
        });
      }
    }
    catch (error) {
      console.error('error = ', error)
    }
  }

  rowEditClick($event) {
    this._router.navigate(['representante', $event.cdConcessionarioPessoa], {
      relativeTo: this._activatedRoute,
      state: {cdConcessao: this.formGroup.value.cdConcessao}
    });
  }

}
